import { ReactElement } from 'react';
import { Message, useMessageGetter } from '@messageformat/react';
import { font, space } from '@op/opds.tokens';
import { IconInformation } from '@op/opds.opux-icons/indicator';
import { Tile, Row, Tab, Tabs } from '@op/opds.opux';
import IndustrySpeficicGraphWrapper from './IndustrySpeficicGraphWrapper';
import { parseMessageList } from '../../../util/messageformatParser';

const data2020 = [
  43.89, 33.3, 23.61, 23.73, 13.45, 30.96, 11.06, 10.75, 2.17, -1.69, -33.68,
];
const data2021 = [
  34.53, 24.43, 21.57, 27.28, 26.13, 23.37, 21.12, 18.63, 46.19, 35.04, 54.64,
];
const data2022 = [
  -28.19, -37.03, -39.89, -12.27, -1.95, -32.45, -5.48, -0.62, -26.13, -10.53, 65.72,
];

const IndustrySpecificGraph = (): ReactElement => {
  const getMessage = useMessageGetter('course2.part2.industry_specific_graph');
  const industryGraphData2020 = data2020.map((value, index) => ({
    name: getMessage(`industries.${index}`),
    value,
  }));
  const industryGraphData2021 = data2021.map((value, index) => ({
    name: getMessage(`industries.${index}`),
    value,
  }));
  const industryGraphData2022 = data2022.map((value, index) => ({
    name: getMessage(`industries.${index}`),
    value,
  }));
  const events2020 = parseMessageList(getMessage('events1'));
  const events2021 = parseMessageList(getMessage('events2'));
  const events2022 = parseMessageList(getMessage('events3'));
  return (
    <div className="investoracademy-graph-wrapper">
      <Tile>
        <h4 className="investoracademy-general-graph-title">
          <Message id="course2.part2.industry_specific_graph.title" />
        </h4>
        <Row>
          <div style={{ textAlign: 'center', width: '100%' }}>
            <Tabs
              style={{ display: 'inline-flex', marginTop: 0, marginBottom: space.small }}
              aria-label={getMessage('alt_text')}
            >
              <Tab label="2020">
                <div style={{ width: '100%' }}>
                  <p
                    style={{ fontSize: font.size.body.medium, paddingBottom: space.xxxs }}
                  >
                    <Message
                      id="course2.part2.industry_specific_graph.subtitle"
                      year={2020}
                    />
                  </p>
                  <IndustrySpeficicGraphWrapper
                    data={industryGraphData2020}
                    events={events2020}
                    listAriaLabel={getMessage('list_aria_label', { year: 2020 })}
                  />
                </div>
              </Tab>
              <Tab label="2021">
                <div style={{ width: '100%' }}>
                  <p
                    style={{ fontSize: font.size.body.medium, paddingBottom: space.xxxs }}
                  >
                    <Message
                      id="course2.part2.industry_specific_graph.subtitle"
                      year={2021}
                    />
                  </p>
                  <IndustrySpeficicGraphWrapper
                    data={industryGraphData2021}
                    events={events2021}
                    listAriaLabel={getMessage('list_aria_label', { year: 2021 })}
                  />
                </div>
              </Tab>
              <Tab label="2022">
                <div style={{ width: '100%' }}>
                  <p
                    style={{ fontSize: font.size.body.medium, paddingBottom: space.xxxs }}
                  >
                    <Message
                      id="course2.part2.industry_specific_graph.subtitle"
                      year={2022}
                    />
                  </p>
                  <IndustrySpeficicGraphWrapper
                    data={industryGraphData2022}
                    events={events2022}
                    listAriaLabel={getMessage('list_aria_label', { year: 2022 })}
                  />
                </div>
              </Tab>
            </Tabs>
          </div>
        </Row>
      </Tile>
      <p
        className="opds-styles-v1-text-label-small"
        style={{ display: 'flex', paddingBottom: space.default }}
      >
        <IconInformation />
        <Message id="course2.part2.industry_specific_graph.sources" />
      </p>
    </div>
  );
};

export default IndustrySpecificGraph;
